import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const LineChart = ({ daysEvent }) => {
  let days = daysEvent
  // console.log(days)
  // let days = [
  //   { "date": "2024-08-22", "count": 8 },
  //   { "date": "2024-08-23", "count": 8 },
  //   { "date": "2024-08-24", "count": 20 },
  //   { "date": "2024-08-25", "count": 6 },
  //   { "date": "2024-08-26", "count": 3 },
  //   { "date": "2024-08-27", "count": 1 },
  //   { "date": "2024-08-28", "count": 86 },
  // ];

  // monday to friday
  // const categories = Array.from({ length: 5 }, (_, i) => {
  //   const date = new Date();
  //   const dayOfWeek = date.getDay();
  //   const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Adjust for Sunday being 0
  //   date.setDate(date.getDate() - daysToSubtract + i); // Get Monday to Friday
  //   return {
  //     dayName: new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date),
  //     date: date.toISOString().split('T')[0] // Format date as YYYY-MM-DD
  //   };
  // });
  // monday to friday

  //sunday to saturday
  const categories = Array.from({ length: 7 }, (_, i) => { // Change length to 7 for Sunday to Saturday
    const date = new Date();
    const dayOfWeek = date.getDay();
    date.setDate(date.getDate() - dayOfWeek + i); // Adjust to get Sunday to Saturday
    return {
      dayName: new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date),
      date: date.toISOString().split('T')[0] // Format date as YYYY-MM-DD
    };
  });
  //sunday to saturday

  // console.log("Categories (Days and Dates):", categories); 

  const options = {
    chart: {
      type: 'line', // Ensure the type is specified for the chart
      height: 400 // Adjust the height as needed (e.g., 400 pixels)
    },
    title: {
      text: '<h4>Total Documents/Income Analyzer Completed For The Week </h4>',
      align: 'left',
      useHTML: true,
      style: {
        color: '#1565c3',
        fontFamily: 'Arial',
        fontWeight: 'Semibold'
      },
      margin: 20
    },
    credits: {
      enabled: false
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    xAxis: {
      title: {
        // text: "Day & Date",
        text: "Day",
      },
      categories: categories.map(cat => {
        const [year, month, day] = cat.date.split('-');
        return `${cat.dayName}`; // Format date as dd-mm-yyyy
        // return `${cat.dayName}<br>(${month}-${day}-${year})`; // Format date as dd-mm-yyyy
      }) // Use day names and dates for categories
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      symbolWidth: 40
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false
        },
        lineWidth: 5,
        marker: {
          radius: 7
        }
      }
    },
    series: [{
      name: `Documents/IA Processed<br>Manually (${Array.isArray(days.resultCurrentWeek) ? days.resultCurrentWeek.reduce((sum, day) => sum + day.count, 0) : 0})`,
      data: Array.isArray(days.resultCurrentWeek) && days.resultCurrentWeek.map(day => day.count), // Map counts to series data
      color: '#8dc640' //'#1f77b4' // Color for Files Completed series
    },
    {
      name: `Automated Documents/IA<br>(${Array.isArray(days.resultForAutoCurrentWeek) ? days.resultForAutoCurrentWeek.reduce((sum, day) => sum + day.count, 0) : 0})`,
      data: Array.isArray(days.resultForAutoCurrentWeek) && days.resultForAutoCurrentWeek.map(day => day.count), // Map pending counts to series data
      color: '#00aeef' //'#ff7f0e' // Color for Files Auto Completed series
    },
    {
      name: `Last Week Documents/IA<br>Processed Manually (${Array.isArray(days.resultPreviousWeek) ? days.resultPreviousWeek.reduce((sum, day) => sum + day.count, 0) : 0})`,
      data: Array.isArray(days.resultPreviousWeek) && days.resultPreviousWeek.map(day => day.count), // Map pending counts to series data
      color: '#c8f5a6', // Lighter green color
      dashStyle: '3,1', // Dashed line style
      lineWidth: 4 // Thick line
    },
    {
      name: `Last Week Automated<br>Documents/IA (${Array.isArray(days.resultForAutoPreviousWeek) ? days.resultForAutoPreviousWeek.reduce((sum, day) => sum + day.count, 0) : 0})`,
      data: Array.isArray(days.resultForAutoPreviousWeek) && days.resultForAutoPreviousWeek.map(day => day.count), // Map pending counts to series data
      color: '#b3e7ff', // Lighter blue color
      dashStyle: '3,1', // Dashed line style
      lineWidth: 4 // Thick line
    },
    ],
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default LineChart;
